<div class="confirm-edit-rule evir-font-default">
  <div mat-dialog-content>
    <p>Editing this rule will override {{ data }} assigned asset(s). Are you sure you want to edit this rule?</p>
  </div>
  <div mat-dialog-actions align="center">
    <app-action-button cdkFocusInitial title="Cancel" (buttonClicked)="dialogRef.close()"></app-action-button>
    <app-action-button title="OK" (buttonClicked)="confirmEdit()"></app-action-button>

  </div>

</div>
